import styled from 'styled-components';
import { theme } from '@bigcommerce/big-design-theme';
import { Text } from '@bigcommerce/big-design';

const SliderRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${theme.spacing.small};
`

const SliderInput = styled.input`
  -webkit-appearance: none;
  appearance: none;
  flex: 1;
  height: 0.25rem;
  border-radius: 0.25rem;
  background: ${theme.colors.secondary30};
  outline: none;
  margin: 0;

  &::-webkit-slider-thumb {
    -webkit-appearance: none;
    appearance: none;
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background: ${theme.colors.primary};
    border: 1px solid ${theme.colors.white};
    box-shadow: 0px 1px 6px rgba(49, 52, 64, 0.2);
    cursor: pointer;
  }

  &::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    border-radius: 50%;
    background: ${theme.colors.primary};
    border: 1px solid ${theme.colors.white};
    box-shadow: 0px 1px 6px rgba(49, 52, 64, 0.2);
    cursor: pointer;
  }

  &::-moz-range-track {
    height: 0.25rem;
    border-radius: 0.25rem;
    background: ${theme.colors.secondary30};
  }

  &:focus {
    box-shadow: 0 0 0 4px ${theme.colors.primary20};
  }

  &:disabled {
    opacity: 0.5;

    &::-webkit-slider-thumb {
      cursor: default;
    }

    &::-moz-range-thumb {
      cursor: default;
    }
  }
`

const Readout = styled(Text)`
  min-width: 2.5rem;
  text-align: right;
`

const PercentSlider = ({ id, value, onChange, disabled }) => {
  const numericValue = parseInt(value) || 0;

  return (
    <SliderRow>
      <SliderInput
        type="range"
        id={id}
        min={0}
        max={100}
        step={1}
        value={numericValue}
        disabled={disabled}
        onChange={(e) => onChange(parseInt(e.target.value))}
      />
      <Readout>{numericValue}%</Readout>
    </SliderRow>
  );
}

export default PercentSlider;
